class NewsletterPopup {
  constructor() {
    this.section = document.querySelector('.section-newsletter-popup');
    if (!this.section) return;

    this.popup = this.section.querySelector('.newsletter-popup');
    this.closeButton = this.section.querySelector('.newsletter-popup__close');
    this.openButtons = document.querySelectorAll('[data-open-modal-newsletter]');
    this.form = this.section.querySelector('.newsletter-popup__form');
    this.defaultContent = this.section.querySelector('.newsletter-popup__content--default');
    this.successContent = this.section.querySelector('.newsletter-popup__content--success');
    this.closeLink = this.section.querySelector('.newsletter-popup__close-link');

    this.init();
  }

  init() {
    // Open popup event listeners
    this.openButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    // Close button event listener
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }

    // Close link event listener (success state)
    if (this.closeLink) {
      this.closeLink.addEventListener('click', () => this.close());
    }

    // Click outside to close
    this.section.addEventListener('click', (e) => {
      if (e.target === this.section) {
        this.close();
      }
    });

    // Form submission event listener
    if (this.form) {
      this.form.addEventListener('submit', (e) => {
        // Let the form submit naturally, but if it's successful, show success state
        // Note: This needs to be handled after page reload for Shopify forms
        // Or use AJAX submission if you want immediate feedback
      });
    }

    // Check if form was successfully submitted (after page reload)
    this.checkFormSuccess();

    // Prevent popup content clicks from closing
    if (this.popup) {
      this.popup.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }

    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.section.classList.contains('active')) {
        this.close();
      }
    });
  }

  open() {
    this.section.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.section.classList.remove('active');
    document.body.style.overflow = '';

    // Reset to default state after closing
    setTimeout(() => {
      if (this.defaultContent && this.successContent) {
        this.defaultContent.classList.remove('hidden');
        this.successContent.classList.remove('active');
        this.successContent.style.display = 'none';
      }
    }, 300);
  }

  showSuccess() {
    if (this.defaultContent && this.successContent) {
      this.defaultContent.classList.add('hidden');
      this.successContent.style.display = 'flex';
      this.successContent.classList.add('active');
    }
  }

  checkFormSuccess() {
    // Check URL parameters for success state
    const urlParams = new URLSearchParams(window.location.search);
    const formPosted = urlParams.get('customer_posted');

    if (formPosted === 'true') {
      // Open popup and show success state
      this.open();
      this.showSuccess();
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new NewsletterPopup();
  });
} else {
  new NewsletterPopup();
}
